import Markdown from 'components/Markdown'
import path from 'resources/markdowns/policy.md'

export default function Policy() {
  return <Markdown path={path} />
}
